import { Buffer } from 'buffer';

// @react-pdf/renderer / pdfkit expect Node's Buffer in the browser bundle
if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer;
}

import { createRoot } from 'react-dom/client';

// third party
import { Provider } from 'react-redux';

// project imports
import App from 'App';
import { store } from 'store';
import * as serviceWorker from 'serviceWorker';
import reportWebVitals from 'reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';
import { ClientConfigProvider } from 'contexts/ClientConfigContext';
import { applyClientConfigToDocument, loadClientConfig } from 'config/clientConfig';

// style + assets
import 'assets/scss/style.scss';

// google-fonts
// Preload critical fonts (for example, Roboto) to reduce FOUC.
// (In a real app, you might add a <link rel="preload" as="font" href="..." crossorigin="anonymous" /> tag in your HTML (or via a plugin) for each critical font.)
// (Below is a dummy example – replace with your actual font URLs if needed.)
// <link rel="preload" as="font" href="https://fonts.gstatic.com/s/roboto/v30/KFOmCnqEu92Fr1Mu4mxK.woff2" crossorigin="anonymous" />
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';

// ==============================|| REACT DOM RENDER ||============================== //

const container = document.getElementById('root');
const root = createRoot(container!);

async function bootstrap() {
  try {
    // Clear stale redux-persist keys from removed Berry cart slice
    localStorage.removeItem('persist:root');
    localStorage.removeItem('berry-cart');

    const clientConfig = await loadClientConfig();
    applyClientConfigToDocument(clientConfig);

    root.render(
      <Provider store={store}>
        <ClientConfigProvider value={clientConfig}>
          <ConfigProvider>
            <App />
          </ConfigProvider>
        </ClientConfigProvider>
      </Provider>
    );
  } catch (error) {
    console.error('Failed to bootstrap app', error);
    root.render(
      <div style={{ padding: 24, fontFamily: 'sans-serif' }}>
        <h1>Unable to load application</h1>
        <p>Please refresh the page. If the problem continues, contact support.</p>
      </div>
    );
  }
}

void bootstrap();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
